import KursTypField from './KursTypField';

export default KursTypField;
